import Repository from '../../../../../foundation/repository/Repository';
import ApiData from '../../../../../foundation/repository/ApiData';
import Exercise from '../aggregates/exercise/Exercise';
import User from '../../../users/domain/aggregates/user/User';
import ExerciseResult from '../aggregates/exerciseResult/ExerciseResult';
import EntityId from '../../../../../foundation/domain/EntityId';
import * as _ from 'lodash';

export default class ExerciseResultRepository extends Repository<ExerciseResult> {

	public getLastByExerciseId (exerciseId: EntityId<Exercise>) {
		const exerciseResults = this.getAll().filter(exerciseResult => exerciseResult.getExerciseId().equals(exerciseId));

		const exerciseResult = exerciseResults.sort((a, b) => b.getNextTimepoint().getMicrotimestamp() - a.getNextTimepoint().getMicrotimestamp())[0];

		if (exerciseResult === undefined) {
			throw new Error('Exercise result not found.');
		}

		return exerciseResult;
	}

	public getAllLast () {
		return _.uniqBy(_.sortBy(this.getAll(), result => -result.getCreatedTimepoint().getMicrotimestamp()), result => result.getExerciseId().getValue());
	}

	public getAllLastByExercises (exercises: Exercise[]) {
		return this.getAllLast().filter(result => exercises.some(exercise => exercise.getId().equals(result.getExerciseId())));
	}

	public mapObject (data: ApiData) {
		return new ExerciseResult(
			data.id<ExerciseResult>('id'),
			data.timepoint('createdTimepoint'),
			data.id<User>('userId'),
			data.id<Exercise>('exerciseId'),
			data.number('step'),
			data.string('value'),
			data.boolean('correct'),
			data.timepoint('nextTimepoint')
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/repositories/ExerciseResultRepository.ts